export const INITIAL_LIST_STATE = { items: [], isLoaded: false, sortOrder: [], isLoading: false };

export const createSortHandlers = (setState) => ({
  onSort: (newItems) => setState(prev => ({ ...prev, sortOrder: [...newItems] })),
  onRemove: (index) => setState(prev => ({ ...prev, sortOrder: prev.sortOrder.filter((_, i) => i !== index) })),
});
